import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function IncludedSection() {
  const fadeIn = useFadeIn();
  const whatYouGet = [{
    emoji: '📚',
    text: '4 libros digitales completos, diseñados para fortalecer la conexión entre padres, hijos y parejas.'
  }, {
    emoji: '🎉',
    text: 'Más de 500 ideas para compartir momentos únicos, divertidos y llenos de emoción.'
  }, {
    emoji: '🗝️',
    text: 'Juegos secretos que revelan lo que sienten tus hijos y mejoran la comunicación familiar.'
  }, {
    emoji: '💌',
    text: 'Frases y actividades con propósito, para que tus hijos nunca olviden cuánto los amás.'
  }, {
    emoji: '🎁',
    text: 'Bonos exclusivos con retos semanales e ideas extras que mantienen viva la magia del vínculo familiar.'
  }];
  const familyBenefits = [{
    emoji: '💬',
    text: 'Charlar más y conectar de verdad, alejándose de las pantallas y volviendo a lo esencial.'
  }, {
    emoji: '😄',
    text: 'Crear recuerdos inolvidables sin gastar mucho dinero, con actividades simples y efectivas.'
  }, {
    emoji: '💖',
    text: 'Fortalecer la confianza y la comunicación, compartiendo momentos sinceros y espontáneos.'
  }, {
    emoji: '⏰',
    text: 'Aprovechar el tiempo juntos, sin necesidad de planificar ni buscar ideas.'
  }, {
    emoji: '🌈',
    text: 'Recuperar la alegría en los pequeños momentos del día a día.'
  }];
  const parentBenefits = [{
    emoji: '✨',
    text: 'Dejar atrás la rutina y vivir experiencias reales que unan a tu familia.'
  }, {
    emoji: '🧠',
    text: 'Descubrir nuevas formas de conectar, entendiendo más a tus hijos y pareja.'
  }, {
    emoji: '💞',
    text: 'Sentirte presente y valorado, sabiendo que estás creando recuerdos para toda la vida.'
  }, {
    emoji: '🎯',
    text: 'Ahorrar tiempo y energía, con ideas listas para usar sin planificar.'
  }, {
    emoji: '🌟',
    text: 'Convertirte en el corazón de tu familia, inspirando amor, unión y diversión.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-91">
          <div className="text-center mb-12" data-id="element-92">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-93">
              💞 Por qué el Pack 100 Citas Familiares es único y especial
            </h2>
            <div className="w-24 h-2 bg-red-600 mx-auto rounded-full" data-id="element-94"></div>
          </div>

          {/* ¿Qué vas a recibir? */}
          <div className="mb-16" data-id="element-95">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-8 text-center" data-id="element-96">
              ¿Qué vas a recibir?
            </h3>
            <div className="space-y-4" data-id="element-97">
              {whatYouGet.map((item, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl border-l-4 border-blue-500" data-id="element-98">
                  <div className="text-3xl flex-shrink-0" data-id="element-99">{item.emoji}</div>
                  <p className="text-lg text-gray-700 font-medium" data-id="element-100">
                    {item.text}
                  </p>
                </div>)}
            </div>
          </div>

          {/* ¿Qué vas a lograr con tu familia? */}
          <div className="mb-16" data-id="element-101">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-8 text-center" data-id="element-102">
              ¿Qué vas a lograr con tu familia?
            </h3>
            <div className="space-y-4" data-id="element-103">
              {familyBenefits.map((item, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-green-50 rounded-xl border-l-4 border-green-500" data-id="element-104">
                  <div className="text-3xl flex-shrink-0" data-id="element-105">{item.emoji}</div>
                  <p className="text-lg text-gray-700 font-medium" data-id="element-106">
                    {item.text}
                  </p>
                </div>)}
            </div>
          </div>

          {/* ¿Qué vas a lograr vos como mamá o papá? */}
          <div className="mb-12" data-id="element-107">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-8 text-center" data-id="element-108">
              ¿Qué vas a lograr vos como mamá o papá?
            </h3>
            <div className="space-y-4" data-id="element-109">
              {parentBenefits.map((item, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-yellow-50 rounded-xl border-l-4 border-yellow-500" data-id="element-110">
                  <div className="text-3xl flex-shrink-0" data-id="element-111">{item.emoji}</div>
                  <p className="text-lg text-gray-700 font-medium" data-id="element-112">
                    {item.text}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}